<template>
  <!-- 课程17 -->
  <div class="lessonTen">
    <div class="web_content">
      <div class="title">第6章 AI的影响（17 人工智能的社会影响 ）</div>
      <div class="content">
        我们对过去了解的越多，对未来的准备就越好。
        <br />在第 6 章中，我们将介绍以下部分。
      </div>
       <div class="content">
        一、
        <span  @click="jumpOne" style="color:#0090ff;cursor: pointer;" class="index">关于预测未来 （0/1）</span>
      </div>
      <div class="content">
        二、
        <span  @click="jumpTow" style="color:#0090ff;cursor: pointer;" class="index">人工智能的社会影响 （0/1）</span>
      </div>
      <div class="content">
        三、
        <span @click="jumpThree" style="color:#0090ff;cursor: pointer;" class="index">总结 （---）</span>
      </div>

      <div class="title-child" id="productId">第2节 人工智能的社会影响</div>

      <div class="content">
        在本课程的开始阶段，我们简要讨论了AI在当今和未来社会中的重要性，但那时我们只能在有限的程度上这样做，因为我们没有引入足够的技术概念和方法来奠定AI的基础。
        <br />既然我们对AI的基本知识有了较深入的了解，那么我们就可以更好地参与到对现有AI影响的理性讨论中来。
      </div>

      <div class="title-child-bold">一、算法偏差</div>
      <div
        class="content"
      >人工智能，尤其是机器学习，已被用于许多领域的重要决策。这就引出了算法偏差的概念，因为在做出有关工作申请、银行贷款等的决策时，存在着种族、性别或其他因素歧视的倾向。</div>

      <div class="title-child-bold">1. 数据偏差</div>

      <div class="content">
        算法偏差的主要原因是数据中的人为偏差。例如，当对工作申请进行有关人类决策的训练时，机器学习算法可能会学会区别对待那些特定种族背景的妇女或个人，即使我们从数据中排除种族或性别的因素，也可能发生这种情况，因为算法能够利用申请人姓名或地址中的信息辨别出种族背景和性别。
        算法偏差并不是学术研究人员设想的假设威胁。这是一种已经在影响着人们的现实现象。
      </div>

      <div class="title-child-bold">2. 在线广告</div>

      <div
        class="content"
      >人们注意到，像Google这样的在线广告商，倾向于向女性用户展示与男性相比工资更低的工作广告。同样，使用听起来像是非裔美国人的名字进行搜索时，可能会产生一个获取用于访问犯罪记录的工具的广告，否则，这种广告就不太可能发生。</div>
      <div class="title-child-bold">3. 社交网络</div>

      <div class="content">
        由于社交网络的内容推荐基本上是基于其他用户的点击而产生，因此即使开始时不觉得怎样，但慢慢地就会导致偏差的放大。例如，当搜索有女性名字的专业人士时，系统可能会询问用户是否真的具有类似的男性名字；搜索“皮德鲁”会导致系统询问“您的意思是皮皮鲁”吗？如果人们偶尔出于好奇而点击皮皮鲁的信息，该系统就将在随后的搜索中进一步提高皮皮鲁的搜索地位。
        <br />我们还可以提及很多其他的例子，您可能已经看过有关它们的新闻报道。使用AI和机器学习而非基于规则的系统的主要困难是缺乏透明度。部分原因是因为算法和数据是商业秘密，这些公司不太可能向公众公开。即使他们这样做，通常也很难识别是算法部分亦或数据元素，导致有区别的决定。
      </div>
      <div class="title-child-bold">二、眼见真的为实吗？</div>
      <div class="content">
        我们习惯于相信我们所看到的。当我们在电视上看到一位领导人说他们的国家将与另一个国家进行贸易战时，或者当一位知名的公司发言人宣布一项重要的商业决定时，我们倾向于信任他们，而不是仅仅从别人写的新闻中间接读到这一声明。
        <br />同样，当我们从犯罪现场看到照片证据时，或观看一个新科技设备的演示时，我们更看重可视证据，而不是说明情况的书面报告。
      </div>

      <img src="../assets/17-01.png" />

      <div class="content">
        然而，眼见就真的为实吗？
        <br />事实上，我们都知道捏造虚假证据的可能性。通过PS，人们可以把图片或照片拼放到从未去过的背景里，也可以与从未见过的人“合影”，还可能通过简单地调整灯光来改变事物的外观，或在最新减肥药广告拍摄时将自己的肚子拉扁绷紧来改变外形。
        <br />现在，AI技术正在将伪造证据的可能性提升到一个全新的水平。例如，利用Face2Face可以识别一个人的面部表情，并将其放置到视频中的另一个人的脸上；利用Lyrebird工具，经过几分钟的采样记录，就能自动模仿别人声音，虽然生成的音频仍然具有明显的机器人音调，但它还是让人觉得很酷。
      </div>
      <div class="title-child-bold">三、转变隐私观念</div>
      <img src="../assets/17-02.png" />
      <div class="content">众所周知，科技公司收集着许多用户的信息。早期主要是杂货店和其他零售商通过向顾客发放会员卡来收集购买数据，会员卡使商店能够将购买与个人顾客联系起来。</div>
      <div class="title-child-bold">1. 前所未有的数据准确性</div>
      <div class="content">
        诸如腾讯、阿里巴巴、Facebook、Google等科技公司，他们收集的数据的准确性远远超出了传统商店收集的购买数据：原则上，他们可以记录每次点击、每一页滚动以及您浏览如何内容所花费的时间。网站甚至可以访问您的浏览历史，因此，除非您在一个站点上浏览飞往巴塞罗那的航班后使用匿名模式（或类似方法），否则您很可能会收到巴塞罗那酒店的广告。
        <br />但是，这样的数据记录还不是AI。使用AI会给我们的隐私带来新的威胁，即使您很小心，也可能难以避免透露自己的身份。
      </div>

      <div class="title-child-bold">2. 使用数据分析来识别个人</div>

      <div
        class="content"
      >一种难以避免的情况是去匿名化（实名制），它打破了我们可能对安全数据匿名性的认识。最基本的问题是，当我们提供数据信息时，由数据得到的分析结果可能非常具体，以至于可以了解有关其数据包含在分析中的各个用户的信息。一个典型的例子是询问给定年份出生并有特定邮政编码的人的平均工资。在很多情况下，这可能是一小群人，也许只有一个人，因此您可能会提供单个人的工资的数据。还有就是对某些事情的投票或者评价之类的情况，都能获得数据背后的信息，如果这些信息被人利用，就有可能左右或影响政治或个人的生活。尽管您可能认为别人是否知道您如何评价最新的电影并不重要，但有些电影可能会揭示我们生活的某些方面（例如政治或性），我们应该有权保密。</div>
      <div class="title-child-bold">3. 其他鉴定方法</div>
      <img src="../assets/17-03.png" />
      <div
        class="content"
      >当早期的人类学会用锋利的岩石劈开死动物的骨头来获取新的营养来源时，时间和精力就被释放出来用于其他目的，例如战斗、寻找伴侣和进行更多的发明。1700年代的蒸汽发动机的发明利用了一种易于携带的机械动力形式，极大地提高了工厂以及轮船和火车的效率。自动化一直是提高效率的途径：事半功倍。特别是自20世纪中叶以来，技术发展导致了自动化领域前所未有的进步，AI是这一进步的延续。</div>

      <div class="title-child-bold">1. 技术进步改变工作</div>

      <div class="content">
        迈向更高自动化水平的每一步都会改变工作寿命。有了锋利的岩石，狩猎和采集食物的需求就减少了；有了蒸汽机，马匹和马夫的需求就减少了；使用计算机，打字员、人工记帐和许多其他数据处理的需求就减少了（显然看视频需求更大了）；有了AI和机器人技术，许多乏味的重复性工作的需求就更少了。
        <br />过去，每一种工作被自动化，人们就会找到新的工作来代替它。新工作种类的重复性和常规性都较低，而可变性和创造性更高。当前AI和其他技术的发展速度所带来的问题是，在个人职业生涯中，工作生活的变化可能比以往任何时候都大。可以想象，一些工作，例如开卡车或出租车，可能会在几年内消失。如此突然的变化可能会导致大规模失业，因为人们没有时间训练自己从事其他工作。
      </div>

      <div class="title-child-bold">2. 可以自动化的工作</div>

      <div class="content">
        什么是更有可能实现自动化的任务呢？关于这一点，我们已经可以观察到一些明显的迹象：
        * 自主机器人解决方案，例如无人驾驶汽车，包括汽车、无人机、船只或渡轮，正处于主要商业应用的边缘。自动驾驶汽车的安全性很难估计，但统计数据表明，它可能尚未达到所需的水平（普通驾驶员的水平）。然而，这一进展速度之快令人难以置信，而且由于可用数据量的增加，这一进展正在加速。
        <br />* 客户服务应用程序（例如服务台）可以以非常经济高效的方式实现自动化。当前，服务质量并不是总能得到满足，瓶颈是语言处理（系统无法识别口语或语法分析）以及提供实际服务所需的逻辑和推理。但是，在受限领域（例如进行餐厅或理发预订）中的工作应用程序在不断涌现。
      </div>

      <div class="title-child-bold">3. 终身学习创造工作</div>

      <div class="content">
        避免诸如此类重大社会问题的最重要的预防措施，是帮助年轻人获得广泛的教育。这为从事许多不同的工作提供了基础，并且在不久的将来这些工作都不会过时。
        <br />支持终身学习和在工作中学习同样重要，因为在我们整个职业生涯中，很少有人会只从事一样的工作。减少每周的工作时间将有助于为更多的人提供工作，但是经济学法则倾向于推动人们更多而不是更少地工作，除非出台公共政策来规范工作量。
        <br />一方面，很难说我们将有多久才能拥有安全可靠的自动驾驶汽车和其他可以代替人类工作的解决方案。另一方面，我们不要忘记，卡车或出租车司机不仅会转动方向盘，而且还负责确保车辆正确运行，处理货物并与客户进行谈判，保证货物和乘客的安全，以及处理许多比驾驶汽车更难完成的其他任务。
        与较早的技术进步一样，AI也会有新的工作产生。将来，很可能有很大一部分劳动力将专注于研发，以及需要创造力和人与人之间互动的能力。
      </div>

      <div class="title-child-bold">【知识巩固】</div>
      <div class="title-child-bold">练习24：AI的影响</div>
      <div class="content">
        关于AI的文章（在报纸和杂志上，或者博客等其他科普媒体上）是怎么样的，你认为它们是现实的吗？做一个与你的兴趣爱好有关的AI的在线搜索，选择其中一篇文章进行分析。
        <br />1.在您的答案中提及文章的标题、作者以及发布的位置（如果合适就采用URL）。
        <br />2.用一段文字（多个句子）用您自己的话来解释文章的中心思想。
        <br />3.根据您的理解，文中与AI相关的陈述的准确性如何？解释您的答案。影响（如果有）是否现实？解释为什么能或者为什么不能。
        <br />您的答案应在40到100个字之间
      </div>

    <div class="content" style="textAlign:center;">你的答案:<input type="text" class="anwserInput" :disabled="contenteditable"></div>

            <button class="sentBtn" style="marginLeft:290px;" @click="sentBtnOne">提交</button>

    </div>

       <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textarea: "",
        contenteditable:false,
    };
  },
  created() {},
  computed: {},
  components: {},
  mounted() {},
  methods: {
     sentBtnOne(){
      this.contenteditable = true;
    },
     jumpOne(){
       this.$router.push('/lessonSixteen');
       
    },
    jumpTow(){
      const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
      
   
   
    jumpThree(){
      this.$router.push('/lessonEighteen');
    },
   
    
    goBlank(){
      this.$router.push('/lessonSixteen');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/lessonEighteen');
    },
  },
};
</script>

<style scoped>
.lessonTen {
  width: 100%;
}
.web_content {
  width: 650px;
  margin: 0 auto;
  padding: 0px 75px;
  background: #fff;
}
.title {
  font-size: 22px;
  color: #000;
  font-weight: bold;
  margin-top: 50px;
}
.content {
  text-indent: 2em;
  font-size: 16px;
  line-height: 35px;
}
.index {
  font-size: 16px;
  color: #0090ff;
  line-height: 15px;
}
.title-child {
  font-size: 22px;
  color: #000;
  margin-top: 30px;
}
.title-child-bold {
  font-size: 16px;
  color: #000;
  margin-top: 30px;

  font-weight: bold;
}

.content-red {
  color: #f15a23;
  font-size: 16px;
  line-height: 35px;
  text-indent: 2em;
}
.content-imgtext {
  margin-left: 40%;
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}

.backBtn button{
  width: 100px;
}
</style>

















// WEBPACK FOOTER //
// src/components/lessonSeventeen.vue